// removed by extract-text-webpack-plugin
module.exports = {"parent":"LegalDisclaimerPopup__parent","modal-content":"LegalDisclaimerPopup__modal-content","modalContent":"LegalDisclaimerPopup__modal-content","divider":"LegalDisclaimerPopup__divider","content":"LegalDisclaimerPopup__content"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/LegalDisclaimerPopup/LegalDisclaimerPopup.css
// module id = 1201
// module chunks = 8